/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import { setObserverSearch, resetObserverSearch } from '../../../../redux/observerSearchSlice';
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export default function ObserverAdvancedSearch({handleOnSubmit,emptyField,setEmptyField}) {
    const observerSearch = useSelector(state => state.observerSearchData);
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()
    const searchApplied = useSelector((state) => state.observerSearchData.obssearchApplied);
    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)

    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;
    
        // Restrict input to only numbers, #, and * for specific fields
        if (['mobile_number', 'main_number', 'main_number_code', 'mobile_number_code'].includes(id)) {
            updatedValue = value.replace(/[^0-9*-]/g, '');
        }
    
        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue;
        }
    
        const updatedState = { ...observerSearch, [id]: updatedValue };
    
        // Handle special cases for username and email
        if (['user_name', 'user_name_domain'].includes(id)) {
            const isUserNameEmpty = updatedState.user_name === '' && updatedState.user_name_domain === '';
            if (isUserNameEmpty) updatedState.user_name_inverse = '';
        }
        if (['email_address', 'email_address_domain'].includes(id)) {
            const isEmailEmpty = updatedState.email_address === '' && updatedState.email_address_domain === '';
            if (isEmailEmpty) updatedState.email_address_inverse = '';
        }
    
        // Handle mobile_number and main_number inverse reset
        if ((id === 'mobile_number' || id === 'mobile_number_code') &&
            updatedState.mobile_number === '' && updatedState.mobile_number_code === '') {
            updatedState.mobile_number_inverse = '';
        }
        if ((id === 'main_number' || id === 'main_number_code') &&
            updatedState.main_number === '' && updatedState.main_number_code === '') {
            updatedState.main_number_inverse = '';
        }
    
        // General case for other fields
        if (!['mobile_number', 'mobile_number_code', 'main_number', 'main_number_code'].includes(id) &&
            updatedValue === '' && updatedState[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
    
        // Update the observerSearch state and dispatch to Redux
        setObserverSearch(updatedState);
        dispatch(setObserverSearch(updatedState));
    };
    
    // handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;

        // Create an updated deviceSearch state
        const updatedState = { ...observerSearch, [field]: checked ? 'true' : '' };

        // Dispatch the updated state
        dispatch(setObserverSearch(updatedState));
    };
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetObserverSearch());
        }
    };

    const isApplyButtonDisabled = () => {
        return Object.entries(observerSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetObserverSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)

    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
        dispatch(resetObserverSearch())
        
        const params = Object.fromEntries(searchParams);
       
        if (params.search) {            
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
       
            // Existing matches for user_id, first_name, last_name and other states
            const userIdMatch = searchDecoded.match(/user_id=(ne:)?(.+?)(;|$)/);
            const firstNameMatch = searchDecoded.match(/first_name=(ne:)?(.+?)(;|$)/);
            const lastNameMatch = searchDecoded.match(/last_name=(ne:)?(.+?)(;|$)/);
            const patAssociatedMatch = searchDecoded.match(/patient_full_name=(ne:)?(.+?)(;|$)/);
            const mainNumberMatch = searchDecoded.match(/main_country_code-main_number=(ne:)?(.+?)(;|$)/);
            const mobileNumberMatch = searchDecoded.match(/mobile_country_code-mobile_number=(ne:)?(.+?)(;|$)/);
            const userNameMatch = searchDecoded.match(/user_name=(ne:)?(.+?)(;|$)/);
            const emailMatch = searchDecoded.match(/email_address=(ne:)?(.+?)(;|$)/);
       
            // Build the new state
            const updatedState = {};

            // Handle user_name field
            if (userNameMatch) {
                const isInverse = !!userNameMatch[1]; // Check if 'ne:' prefix is present
                const userNameValue = userNameMatch[2]; // Extract the user_name value after 'ne:'
                const [namePart, domainPart] = userNameValue.split('@');
    
                updatedState.user_name = namePart === '__NULL__' ? '-' : namePart || ''; // Before '@' part
                updatedState.user_name_domain = domainPart === '__NULL__' ? '-' : domainPart || ''; // After '@' part
                updatedState.user_name_inverse = isInverse ? 'true' : ''; // Inverse checkbox
            }

            // Handle email_address field
            if (emailMatch) {
                const isInverse = !!emailMatch[1]; // Check if 'ne:' prefix is present
                const emailValue = emailMatch[2]; // Extract the email_address value after 'ne:'
                const [namePart, domainPart] = emailValue.split('@');

                updatedState.email_address = namePart === '__NULL__' ? '-' : namePart || ''; // Before '@' part
                updatedState.email_address_domain = domainPart === '__NULL__' ? '-' : domainPart || ''; // After '@' part
                updatedState.email_address_inverse = isInverse ? 'true' : ''; // Inverse checkbox
            }
       
            // handle user_id field
            if (userIdMatch) {
                const isInverse = !!userIdMatch[1]; 
                const userIdValue = userIdMatch[2]; 
       
                updatedState.user_id = userIdValue === '__NULL__' ? '-' : userIdValue;
                updatedState.user_id_inverse = isInverse ? 'true' : '';
            }
                
            // Handle first_name field
            if (firstNameMatch) {
                const isInverse = !!firstNameMatch[1];
                const firstNameValue = firstNameMatch[2];
                updatedState.first_name = firstNameValue === '__NULL__' ? '-' : firstNameValue;
                updatedState.first_name_inverse = isInverse ? 'true' : '';
            }

            // Handle last_name field
            if (lastNameMatch) {
                const isInverse = !!lastNameMatch[1];
                const lastNameValue = lastNameMatch[2];
                updatedState.last_name = lastNameValue === '__NULL__' ? '-' : lastNameValue;
                updatedState.last_name_inverse = isInverse ? 'true' : '';
            }

            // Handle patient_associated field
            if (patAssociatedMatch) {
                const isInverse = !!patAssociatedMatch[1];
                const patAssociatedValue = patAssociatedMatch[2];
                updatedState.patient_associated = patAssociatedValue === '__NULL__' ? '-' : patAssociatedValue;
                updatedState.patient_associated_inverse = isInverse ? 'true' : '';
            }
       
            // Handle main_number field
            if (mainNumberMatch) {
                const isInverse = !!mainNumberMatch[1];
                let mainNumberValue = mainNumberMatch[2];
       
                // Remove leading '+' if present
                if (mainNumberValue.startsWith('+')) {
                    mainNumberValue = mainNumberValue.slice(1);
                }
       
                const [mainCode, mainNumber] = mainNumberValue.split('-');
       
                updatedState.main_number_code = mainCode === '__NULL__' ? '-' : mainCode;
                updatedState.main_number = mainNumber === '__NULL__' ? '-' : mainNumber;
                updatedState.main_number_inverse = isInverse ? 'true' : '';
            }

            // Handle mobile_nunmber field
            if (mobileNumberMatch) {
                const isInverse = !!mobileNumberMatch[1];
                let mobileNumberValue = mobileNumberMatch[2];
       
                // Remove leading '+' if present
                if (mobileNumberValue.startsWith('+')) {
                    mobileNumberValue = mobileNumberValue.slice(1);
                }
       
                const [mobileCode, mobileNumber] = mobileNumberValue.split('-');
       
                updatedState.mobile_number_code = mobileCode === '__NULL__' ? '-' : mobileCode;
                updatedState.mobile_number = mobileNumber === '__NULL__' ? '-' : mobileNumber;
                updatedState.mobile_number_inverse = isInverse ? 'true' : '';
            }
                
            // Handle search_mode if applicable
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or' ? true : false;
            }
       
            // Dispatch the action to update Redux state
            setTimeout(() => {
                dispatch(setObserverSearch(updatedState));
            }, 0);
        }
    }, [isAdvancedSearchOpen]);

    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action=''
                onSubmit={(e) => handleOnSubmit(e)} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={observerSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${observerSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!observerSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!observerSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"ID"}
                                    placeholder={"Enter ID"}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={observerSearch.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        checked={observerSearch.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Username</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"user_name"}
                                        data_testid={"user_name"}
                                        htmlFor={"user_name"}
                                        value={observerSearch?.user_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"user_name_domain"}
                                        data_testid={"user_name_domain"}
                                        htmlFor={"user_name_domain"}
                                        value={observerSearch.user_name_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_name_inverse')}
                                        checked={observerSearch.user_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.user_name_domain?.trim()===""&&observerSearch?.user_name?.trim()===""}
                                    />
                                    <label htmlFor='user_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"First Name"}
                                    placeholder={"Enter first name"}
                                    id={"first_name"}
                                    data_testid={"first_name"}
                                    htmlFor={"first_name"}
                                    value={observerSearch?.first_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='first_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'first_name_inverse')}
                                        checked={observerSearch?.first_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.first_name?.trim()===""}
                                    />
                                    <label htmlFor='first_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Last Name"}
                                    placeholder={"Enter last name"}
                                    id={"last_name"}
                                    data_testid={"last_name"}
                                    htmlFor={"last_name"}
                                    value={observerSearch?.last_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='last_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'last_name_inverse')}
                                        checked={observerSearch?.last_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.last_name?.trim()===""}
                                    />
                                    <label htmlFor='last_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Patient Associated with"}
                                    placeholder={"Enter patient associated with"}
                                    id={"patient_associated"}
                                    data_testid={"patient_associated"}
                                    htmlFor={"patient_associated"}
                                    value={observerSearch?.patient_associated}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='patient_associated_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'patient_associated_inverse')}
                                        checked={observerSearch?.patient_associated_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.patient_associated?.trim()===""}
                                    />
                                    <label htmlFor='patient_associated_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Email Address</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"email_address"}
                                        data_testid={"email_address"}
                                        htmlFor={"email_address"}
                                        value={observerSearch?.email_address}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"email_address_domain"}
                                        data_testid={"email_address_domain"}
                                        htmlFor={"email_address_domain"}
                                        value={observerSearch?.email_address_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='email_address_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'email_address_inverse')}
                                        checked={observerSearch?.email_address_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.email_address?.trim()===""&&observerSearch?.email_address_domain.trim()===""}
                                    />
                                    <label htmlFor='email_address_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Mobile Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"mobile_number_code"}
                                            data_testid={"mobile_number_code"}
                                            htmlFor={"mobile_number_code"}
                                            value={observerSearch?.mobile_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"mobile_number"}
                                        data_testid={"mobile_number"}
                                        htmlFor={"mobile_number"}
                                        value={observerSearch?.mobile_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='mobile_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'mobile_number_inverse')}
                                        checked={observerSearch?.mobile_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.mobile_number_code?.trim()==="" && observerSearch?.mobile_number?.trim()===""}
                                    />
                                    <label htmlFor='mobile_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Main Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"main_number_code"}
                                            data_testid={"main_number_code"}
                                            htmlFor={"main_number_code"}
                                            value={observerSearch?.main_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"main_number"}
                                        data_testid={"main_number"}
                                        htmlFor={"main_number"}
                                        value={observerSearch?.main_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='main_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'main_number_inverse')}
                                        checked={observerSearch?.main_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={observerSearch?.main_number_code?.trim()==="" && observerSearch?.main_number?.trim()===""}
                                    />
                                    <label htmlFor='main_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
